import {combineReducers} from 'redux';
import types from './types';

const INITIAL_STATE = {type: '', title: '', context: [], open: false, action: ''};

// 通信中
const isRequesting = (state = false, action) => {
  switch (action.type) {
    case types.START_REQUEST:
      return true;
    case types.END_REQUEST:
      return false;
    default:
      return state;
  }
};

// メッセージダイアログ
const dialogInfo = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.OPEN_DIALOG:
      return action.dialogInfo;
    case types.CLOSE_DIALOG:
      // 高優先度のメッセージを閉じた際、高優先度フラグを削除
      if (state.hasOwnProperty('highPriority')) {
        delete state.highPriority;
      }
      return {...state, open: false};
    default:
      return state;
  }
};

// モーダル
const modalInfo = (state = {btnExist: false, open: false}, action) => {
  switch (action.type) {
    case types.OPEN_MODAL:
      return action.modalInfo;
    case types.CLOSE_MODAL:
      return {btnExist: false, open: false};
    default:
      return state;
  }
};

const reducer = combineReducers({
  isRequesting,
  dialogInfo,
  modalInfo,
});

export default reducer;
